module.exports = __webpack_public_path__ + "img/walkthrough_illust7@2x.e800bc7e.png";